module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338600/point03-edd713e63f328f931b86075311099696.png";